module.exports = __webpack_public_path__ + "static/doors-839004399431dbbfaf860e578011168d.jpg";